<template>
  <img
    class="border-radius-4"
    :alt="code"
    :src="imgSrc"
    :height="height"
  >
</template>

<script setup>
import { computed } from 'vue';

// vite rewrites glob keys to resolved paths, so index by country code instead
const flagIcons = Object.fromEntries(
  Object.entries(import.meta.glob('flag-icons/flags/4x3/*.svg', {
    eager: true,
    query: '?url&no-inline',
    import: 'default',
  })).map(([key, url]) => [key.slice(key.lastIndexOf('/') + 1, -'.svg'.length), url]),
);

const props = defineProps({
  code: {
    type: String,
    required: true,
  },
  forceCode: {
    type: Boolean,
    default: false,
  },
  height: {
    type: String,
    default: '18',
  },
});

const flag = computed(() => {
  const code = props.code.toLowerCase();

  if (props.forceCode) {
    return code;
  }

  const alias = {
    en: 'gb',
    cs: 'cz',
    he: 'il',
    ja: 'jp',
    ko: 'kr',
    sv: 'se',
    el: 'gr',
    bn: 'bd',
    ur: 'pk',
    sr: 'rs',
    am: 'et',
    uk: 'ua',
  };

  return alias[code] || code;
});

const imgSrc = computed(() => {
  if (flag.value.startsWith('zh') || (!props.forceCode && flag.value === 'ar')) {
    return `common/img/${flag.value}.svg`;
  }

  return flagIcons[flag.value];
});
</script>

<style lang="scss" scoped>
img {
  box-shadow: 0 0 0 .5px #ccc;
}
</style>
